import { InputAdornment, useTheme } from "@mui/material";
import EditNoteIcon from '@mui/icons-material/EditNote';
import FormField from "../../../ui/FormField";
import IconCircleWrapper from "../../../ui/IconCircleWrapper";
import { useTranslation } from "react-i18next";
import { ForwardedRef, forwardRef } from "react";

interface DescriptionFieldProps {
  description: string;
  setDescription: (description: string) => void;
  readOnly?: boolean;
}

const DescriptionField = forwardRef(({ description, setDescription, readOnly = false }: DescriptionFieldProps, ref: ForwardedRef<HTMLInputElement>) => {
  const { t } = useTranslation(['transactions']);
  const theme = useTheme();

  return (
    <FormField
      multiline
      fullWidth
      maxRows={4}
      variant="standard"
      value={description}
      margin="normal"
      name="description"
      inputRef={ref}
      ref={ref}
      label={t('note', { ns: 'transactions' })}
      placeholder={t('note_placeholder', { ns: 'transactions' })}
      onChange={readOnly ? undefined : (e) => setDescription(e.target.value)}
      slotProps={{
        input: {
          readOnly: readOnly,
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 0 }}>
              <IconCircleWrapper size={30} bgcolor={theme.palette.navy[800]} color={theme.palette.common.white}>
                <EditNoteIcon sx={{ fontSize: 18 }} />
              </IconCircleWrapper>
            </InputAdornment>
          )
        }
      }}
    />
  );
});

DescriptionField.displayName = 'DescriptionField';

export default DescriptionField; 